export const SITE_CONFIG = {
  social: {
    whatsapp: 'https://wa.me/972505877179',
    linkedin: 'https://www.linkedin.com/in/idanlevian/',
    facebook: 'https://www.facebook.com/idanLevianDeveloper',
  },
} as const;
